export default "__VITE_ASSET__BQ9KO8rm__";